import React from 'react'
import { motion } from 'framer-motion'
import { ChevronDown } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { DNAHelix, MoleculeCluster, HexGrid } from './BackgroundElements'

const Hero = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background layers - Removed as they are now in Layout via BackgroundElements */}
      
      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">


        {/* Mobile-Only Tagline */}
        <motion.div 
          className="lg:hidden mb-6 flex justify-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="inline-block px-4 py-1.5 rounded-full bg-surface-50 border border-primary/20 backdrop-blur-sm">
            <span className="text-[10px] sm:text-xs font-bold text-primary tracking-widest uppercase">
              Bioinformatics & AI for Life Sciences
            </span>
          </div>
        </motion.div>

        {/* Headline */}
        <motion.h1
          className="mt-10 font-display font-bold leading-[0.95] tracking-tighter text-4xl sm:text-5xl md:text-6xl lg:text-7xl"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-gradient-green">{t('hero.headline.part1')}</span>
          <br />
          <span className="text-text-main text-2xl sm:text-3xl md:text-4xl lg:text-5xl">{t('hero.headline.part2')}</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          className="mt-8 text-text-muted max-w-2xl mx-auto leading-relaxed text-base sm:text-lg"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          {t('hero.subheadline')}
        </motion.p>

        {/* CTAs */}
        <motion.div className="mt-12 flex flex-wrap justify-center gap-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.9 }}>
          <button onClick={() => navigate('/service')} className="btn-ghost px-8 py-4 text-base flex items-center gap-2.5">
            {t('hero.cta.explore')}
          </button>
        </motion.div>

        {/* Stats */}
        <motion.div className="mt-12 sm:mt-20 flex flex-wrap justify-center gap-6 sm:gap-16" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 1.2 }}>
          {[
            { value: '50+', label: t('hero.stats.modules') },
            { value: '4', label: t('hero.stats.domains') },
            { value: '100%', label: t('hero.stats.security') },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl sm:text-4xl font-display font-bold text-gradient-green">{stat.value}</div>
              <div className="text-[10px] sm:text-xs text-text-dim mt-1 uppercase tracking-widest">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2 }}>
        <motion.div animate={{ y: [0, 8, 0] }} transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}>
          <ChevronDown className="w-5 h-5 text-text-dim" />
        </motion.div>
      </motion.div>
    </section>
  )
}

export default Hero
